import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-eb076972")
const _hoisted_1 = {
  id: "units",
  class: "list-group align-self-center"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "progress w-50",
  style: {"height":"20px"}
}
const _hoisted_4 = ["id"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = { key: 3 }
const _hoisted_8 = ["onClick", "title"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick", "title"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-eye" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["onClick", "title"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-eye-slash" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["onClick", "title"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["onClick", "title"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-save" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 0,
  class: "d-flex align-self-center"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NoContent = _resolveComponent("NoContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lessons, (lesson, index) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        lesson: lesson,
        key: lesson.id,
        title: `Lektion ${lesson.name} anzeigen`,
        to: `/lesson/${lesson.id}/`,
        class: "list-group-item list-group-item-action d-flex justify-content-between align-items-center"
      }, {
        default: _withCtx(() => [
          (_ctx.editLessons.lessonId !== lesson.id)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(lesson.name), 1))
            : _createCommentVNode("", true),
          (_ctx.user.type==='student')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", {
                  id: lesson.name,
                  class: _normalizeClass(_ctx.getLessonStyle(_ctx.courseStats.lessons[index].progress)),
                  role: "progressbar",
                  style: _normalizeStyle({width: _ctx.getLessonProgress(index)+'%'})
                }, _toDisplayString(_ctx.roundProgress(_ctx.courseStats?.lessons?.[index]?.progress)) + "% ", 15, _hoisted_4)
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.type==='teacher' && _ctx.editLessons.editable===true && _ctx.editLessons.lessonId === lesson.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent","self"])),
                  "onUpdate:modelValue": ($event: any) => (lesson.name = $event)
                }, null, 8, _hoisted_6), [
                  [_vModelText, lesson.name]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.type==='administrator' || _ctx.user.type ==='teacher')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_ctx.user.type==='administrator' || _ctx.user.type ==='teacher')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _withModifiers(($event: any) => (_ctx.deleteLesson(lesson)), ["stop","prevent"]),
                      class: "btn btn-outline-red mr-2",
                      title: _ctx.$t('messages.del lesson')
                    }, _hoisted_10, 8, _hoisted_8))
                  : _createCommentVNode("", true),
                (_ctx.user.type==='teacher' && lesson.visibility === true)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _withModifiers(($event: any) => (_ctx.changeVisibility(lesson)), ["stop","prevent"]),
                      class: "btn btn-outline-secondary mr-2",
                      title: _ctx.$t('messages.hide lesson')
                    }, _hoisted_13, 8, _hoisted_11))
                  : _createCommentVNode("", true),
                (_ctx.user.type==='teacher' && lesson.visibility === false)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      onClick: _withModifiers(($event: any) => (_ctx.changeVisibility(lesson)), ["stop","prevent"]),
                      class: "btn btn-outline-secondary mr-2",
                      title: _ctx.$t('messages.show lesson')
                    }, _hoisted_16, 8, _hoisted_14))
                  : _createCommentVNode("", true),
                (_ctx.user.type==='teacher' && _ctx.editLessons.lessonId!==lesson.id)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      onClick: _withModifiers(($event: any) => (_ctx.changeEditLessons(lesson.id)), ["stop","prevent"]),
                      "data-toggle": "modal",
                      "data-target": "#editLesson",
                      class: "btn btn-outline-primary",
                      title: _ctx.$t('messages.edit lesson')
                    }, _hoisted_19, 8, _hoisted_17))
                  : _createCommentVNode("", true),
                (_ctx.user.type==='teacher' && _ctx.editLessons.editable===true && _ctx.editLessons.lessonId===lesson.id)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 4,
                      onClick: _withModifiers(($event: any) => (_ctx.updateLesson(lesson)), ["stop","prevent"]),
                      "data-toggle": "modal",
                      "data-target": "#editLesson",
                      class: "btn btn-outline-primary",
                      title: _ctx.$t('messages.edit lesson')
                    }, _hoisted_22, 8, _hoisted_20))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["lesson", "title", "to"]))
    }), 128)),
    (_ctx.lessons.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createVNode(_component_NoContent, {
            text: _ctx.$t('messages.no lesson')
          }, null, 8, ["text"])
        ]))
      : _createCommentVNode("", true)
  ]))
}